import { z } from 'zod';

// ── School Response ──

export const SchoolResponseSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  domain: z.string().nullable(),
  industry: z.string().nullable(),
  employee_count: z.number().int().nullable(),
  employee_range: z.string().nullable(),
  hq_city: z.string().nullable(),
  hq_country: z.string().nullable(),
  logo_url: z.string().nullable(),
  linkedin_url: z.string().nullable(),
  linkedin_id: z.string().nullable(),
  website: z.string().nullable(),
  year_founded: z.number().int().nullable(),
  licence_id: z.uuid().nullable(),
  list_id: z.uuid().nullable(),
  data_updated_at: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
});
export type SchoolResponse = z.infer<typeof SchoolResponseSchema>;

// ── Wrappers ──

export const SchoolListResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(SchoolResponseSchema),
});
export type SchoolListResponse = z.infer<typeof SchoolListResponseSchema>;
